import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { SizeProps } from 'styled-system';
import { size } from 'styled-system';

import type { StrokeProps } from 'common/theme/system-types';
import type { StrokeWidthProps } from '../../../theme/system-utilities';
import { stroke, strokeWidth } from '../../../theme/system-utilities';
import Icon from '../../Icon';

const NAVIGATION_ARROW_SIZE = 16;

const ArrowIcon = styled(Icon)<
  SizeProps &
    StrokeProps &
    StrokeWidthProps & {
      alt?: string;
    }
>`
  ${size};
  ${stroke};
  ${strokeWidth};
`;

export const arrowIconStyles: ComponentProps<typeof ArrowIcon> = {
  name: 'arrowRight',
  size: NAVIGATION_ARROW_SIZE,
  strokeWidth: '2px',
};

export default ArrowIcon;
